<template>
  <div class="content">
    <Title :title="'会员列表'"></Title>
    <div class="search">
      <div class="flex">
        <p>会员昵称</p>
        <input type="text" placeholder="会员昵称" class="inputStyle" v-model="search.nickName">
      </div>
      <div class="flex">
        <p>下单次数</p>
        <input min="0" type="number" placeholder="下单次数" class="inputStyle" v-model="search.minKfcOrderCount" @blur="orderNumberStartBlur"
          style="margin-right: 10px;">
        <p>至</p>
        <input min="0" type="number" placeholder="下单次数" class="inputStyle" v-model="search.maxKfcOrderCount" @blur="orderNumberEndBlur">
      </div>
      <div class="flex">
        <p>注册日期</p>
        <DatePicker type="date" placeholder="开始时间" style="width: 150px;margin-right: 10px;margin-bottom: 8px;margin-top: 8px;"
          v-model="search.registerStartTime" @on-change="handelDateChangeStart"></DatePicker>
        <p>至</p>
        <DatePicker type="date" placeholder="结束时间" style="width: 150px;margin-bottom: 8px;margin-top: 8px;" v-model="search.registerEndTime"
          @on-change="handelDateChangeEnd"></DatePicker>
      </div>
      <div class="searchBtn" @click="queryBtn">查询</div>
    </div>

    <div class="table">
      <el-table v-loading="listLoading" :data="tableData" style="width: 100%" :highlight-current-row="true"
        :header-cell-style="{background:'#FCFAF8',fontSize: '16px',fontFamily: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi',fontWeight: 'normal',color: '#222222'}">
        <el-table-column label="序号" type="index" align="center" width="58">
        </el-table-column>
        <!-- <el-table-column label="微信名" prop="nickName" align="center" min-width="250px">
        </el-table-column>
        <el-table-column label="下单次数" prop="kfcOrderCount" align="center" min-width="160px">
        </el-table-column> -->
        <el-table-column label="微信昵称" align="center" min-width="200">
          <template slot-scope="{row}">
            <div class="WxInfo">
              <img :src="row.headPic" alt="" style="height: 50px; width: 50px; margin-right: 30px;">
              <span>{{ row.nickName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="肯德基下单次数" align="center" min-width="90" prop="kfcOrderCount">

        </el-table-column>
        <el-table-column label="电费下单次数" align="center" min-width="90" prop="electricityOrderCount">

        </el-table-column>
        <el-table-column label="注册时间" prop="registerTimeStr" align="center" min-width="200">
        </el-table-column>
        <el-table-column label="最后下单时间" prop="lastOrderTimeStr" align="center" min-width="200">
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <Page v-if="total > 0" :total="total" :current="pageNo" show-sizer show-elevator show-total @on-change="changePage"
        @on-page-size-change="changePagesize"></Page>
    </div>
  </div>
</template>

<script>
import Title from './components/title.vue'
import { DatePicker, Page } from 'view-design'
import { getMemberList, getWxList } from '@/api/open.js'
import { getDate } from '@/utils/date'

export default {
  name: '',
  components: { Title, DatePicker, Page },
  props: {},
  data() {
    return {
      search: {},
      tableData: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      listLoading: false
    }
  },
  computed: {},
  watch: {},
  created() {
    if (this.$store.getters.appKey.length === 0 && this.$store.getters.userToken !== '') {
      this.$message.warning('请先添加公众号')
      this.$router.push('/pc/open/application')
    }
    if (this.$store.getters.appKey.length > 0) {
      this.getList()
    }
  },
  mounted() {},
  activated() {},
  deactivated() {},
  destroyed() {},
  methods: {
    getList() {
      this.listLoading = true
      let userParam = {
        registerEndTime: getDate(this.search.registerEndTime),
        registerStartTime: getDate(this.search.registerStartTime)
      }
      if (userParam.registerStartTime) {
        userParam.registerStartTime = userParam.registerStartTime + ' 00:00:00'
      } else {
        delete userParam.registerStartTime
      }
      if (userParam.registerEndTime) {
        userParam.registerEndTime = userParam.registerEndTime + ' 23:59:59'
      } else {
        delete userParam.registerEndTime
      }
      getMemberList({
        ...userParam,
        appKey: this.$store.getters.showAppKey.appKey,
        nickName: this.search.nickName,
        maxKfcOrderCount: this.search.maxKfcOrderCount,
        minKfcOrderCount: this.search.minKfcOrderCount,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      })
        .then(res => {
          this.tableData = res.data.list
          if (res.data.pageNo === 0) {
            this.total = 0
            this.pageNo = 1
          } else {
            this.total = res.data.total
            this.pageNo = res.data.pageNo
            this.pageSize = res.data.pageSize
          }
          this.listLoading = false
        })
        .catch(err => {
          this.tableData = []
          this.listLoading = false
          this.total = 0
          this.pageNo = 1
        })
    },
    //查询
    queryBtn() {
      console.log('search', this.search)
      this.pageNo = 1
      this.getList()
    },
    handelDateChangeStart(time, type) {
      if (type == 'date') {
        if (this.search.timeEnd !== '') {
          if (this.compareTime(time, this.search.timeEnd)) {
            this.search.timeStart = this.search.timeEnd
          }
        }
      }
    },
    handelDateChangeEnd(time, type) {
      if (type == 'date') {
        if (this.search.timeStart !== '') {
          if (this.compareTime(this.search.timeStart, time)) {
            this.search.timeEnd = this.search.timeStart
          }
        }
      }
    },
    compareTime(startTime, endTime) {
      var oDate1 = new Date(startTime)
      var oDate2 = new Date(endTime)
      if (oDate1.getTime() > oDate2.getTime()) {
        return true
      } else {
        return false
      }
    },
    orderNumberStartBlur() {
      if (this.search.orderNumberEnd) {
        if (this.search.orderNumberStart > this.search.orderNumberEnd) {
          this.search.orderNumberStart = this.search.orderNumberEnd
        }
      }
    },
    orderNumberEndBlur() {
      if (this.search.orderNumberStart) {
        if (this.search.orderNumberStart > this.search.orderNumberEnd) {
          this.search.orderNumberEnd = this.search.orderNumberStart
        }
      }
    },
    changePage(value) {
      console.log(value)
      this.pageNo = value
      this.getList()
    },
    changePagesize(value) {
      console.log(value)
      this.pageSize = value
      this.getList()
    }
  }
}
</script>
<style lang='less' scoped>
.content {
  .search {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    // justify-content: space-between;
    margin-top: 20px;
    z-index: 99;

    p {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      margin-right: 10px;
    }
    ::placeholder {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #c1c1c1;
    }
    .inputStyle {
      box-sizing: border-box;
      width: 150px;
      height: 32px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #eeeeee;
      padding-left: 10px;
      margin-right: 20px;
      margin-bottom: 8px;
      margin-top: 8px;
    }
    :hover {
      border-color: #57a3f3;
    }
    .searchBtn {
      width: 90px;
      height: 32px;
      background: #ff8622;
      border-radius: 2px;
      text-align: center;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      line-height: 32px;
      color: rgba(255, 255, 255, 0.8);
      // margin-top: 16px;
      margin-left: 20px;
      margin-bottom: 8px;
      margin-top: 8px;
      cursor: pointer;
    }
  }

  .table {
    border: 1px solid #eeeeee;
    margin-top: 30px;
  }
  .page {
    // margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.flex {
  display: flex;
  align-items: center;
}
.WxInfo {
  display: flex;
  align-items: center;
  padding: 0 10px;
  // justify-content: space-between;

  img {
    margin-right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/open/member.vue